// extracted by mini-css-extract-plugin
export default {"dialog":"style_dialog__p6yv1","dialog__fillpage":"style_dialog__fillpage__3Du-f","dialog__body":"style_dialog__body__7R+vQ"};